import POS from './PosContainer'
import './pos.css'
export default POS